import EmailLists from '../../pages/neverbounce/EmailLists.vue';

export default [
  {
    path: '/v2/admin/verify/email-lists',
    name: 'admin.neverbounce.email_lists.index',
    component: EmailLists,
  },
]
